export default "__VITE_ASSET__DnVB87uO__"